export const CHANGESEARCHFIELD = 'CHANGESEARCHFIELD';

export const REQUEST_ROBOTS_PENDING = 'REQUEST_ROBOTS_PENDING';

export const REQUEST_ROBOTS_SUCCESS = 'REQUEST_ROBOTS_SUCCESS';

export const REQUEST_ROBOTS_FAILED = 'REQUEST_ROBOTS_FAILED';

